import { render, staticRenderFns } from "./AnonymousFooter.vue?vue&type=template&id=55f073c0&scoped=true&"
var script = {}
import style0 from "./AnonymousFooter.vue?vue&type=style&index=0&id=55f073c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f073c0",
  null
  
)

export default component.exports